/**
 * TextField — text input overlay for signing ceremony
 */

import type { FieldPlacement } from './types';

interface TextFieldProps {
  placement: FieldPlacement;
  value: string;
  onChange: (value: string) => void;
  fieldIndex: number;
}

export function TextField({ placement, value, onChange, fieldIndex }: TextFieldProps): JSX.Element {
  return (
    <input
      type="text"
      data-testid={`text-field-${fieldIndex}`}
      value={value}
      onChange={(e) => onChange(e.target.value)}
      placeholder={placement.label ?? 'Enter text'}
      aria-label={placement.label ?? 'Text field'}
      className="w-full h-full px-1 py-0.5 text-xs border border-primary/60 rounded bg-card focus:outline-none focus:ring-2 focus:ring-ring min-h-[44px]"
    />
  );
}

export default TextField;
